module.exports = __webpack_public_path__ + "static/media/FBTImage.3b8f6afc.svg";